import * as redux from 'react-redux'
import { AppDispatch, RootState } from './common/redux'

export const useDispatch = (): AppDispatch => redux.useDispatch<AppDispatch>()
export const useSelector: redux.TypedUseSelectorHook<RootState> =
	redux.useSelector
